module.exports = __webpack_public_path__ + "52e9b50454449455286ad2220d1a27c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/VVS1@2x.png
// module id = 814
// module chunks = 0